














import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({ name: 'RecordTemplateTeacher' })
export default class RecordTemplateTeacher extends Vue {
  @Prop()
  private bus: Vue;

  @Prop()
  private value: string;

  @Prop()
  private optionList: any[];

  get skxxId(): string { return this.value; }

  set skxxId(value: string) { this.$emit('input', value); }

  private format(label: string): string {
    return label ? label : '';
  }


  // private mounted() {
  // }
}
